module.exports = __webpack_public_path__ + "static/media/3.fef0b954.jpg";